import { FETCH_ADHERENCE_HISTORY } from '../actions';

const initialState = {
	protocol: { current: [], all_items: [] },
	book: { current: [], all_items: [] },
	event: { current: [], all_items: [] },
	ondemand: { current: [], all_items: [] },
};

export default function(state = initialState, action) {
	switch (action.type) {
		case FETCH_ADHERENCE_HISTORY:
			var tabType = action.payload.tabType;
			var data = action.payload.data;
			var previousItems = (state[tabType] && state[tabType].all_items) ? state[tabType].all_items : [];

			var updatedTabData = {
				current: data,
				all_items: previousItems.concat(data)
			};

			var newState = {};
			for (var key in state) {
				if (state.hasOwnProperty(key)) {
					newState[key] = (key === tabType) ? updatedTabData : state[key];
				}
			}

			return newState;

		default:
			return state;
	}
}